import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

/**
 * Dil dosyaları statik olarak import edilmiyor.
 *
 * On dosyanın hepsi `import en from 'language/en.json'` şeklinde bundle'a
 * gömülüydü; tek başına ~4.2 MB ham JSON demekti — ve kullanıcı bunların
 * yalnızca birini kullanıyor. `import()` ile her dil kendi chunk'ına ayrılıyor
 * ve sadece seçili dil (+ fallback) indiriliyor.
 */
const loaders = {
  en: () => import(/* webpackChunkName: "lang-en" */ 'language/en.json'),
  de: () => import(/* webpackChunkName: "lang-de" */ 'language/de.json'),
  tr: () => import(/* webpackChunkName: "lang-tr" */ 'language/tr.json'),
  nl: () => import(/* webpackChunkName: "lang-nl" */ 'language/nl.json'),
  bg: () => import(/* webpackChunkName: "lang-bg" */ 'language/bg.json'),
  fr: () => import(/* webpackChunkName: "lang-fr" */ 'language/fr.json'),
  pt: () => import(/* webpackChunkName: "lang-pt" */ 'language/pt.json'),
  es: () => import(/* webpackChunkName: "lang-es" */ 'language/es.json'),
  zh: () => import(/* webpackChunkName: "lang-zh" */ 'language/zh.json'),
  fa: () => import(/* webpackChunkName: "lang-fa" */ 'language/fa.json')
};

// i18next'in minimal backend arayüzü: tek iş, istenen dili çözmek.
const dynamicImportBackend = {
  type: 'backend',
  init: () => {},
  read(language, namespace, callback) {
    const load = loaders[language];
    if (!load) {
      // Bilinmeyen dil hata değil: i18next fallback zincirine geçsin.
      callback(null, {});
      return;
    }
    load()
      .then((mod) => callback(null, mod.default ?? mod))
      .catch((error) => callback(error, null));
  }
};

export const i18nReady = i18n
  .use(dynamicImportBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // Kaynaklar yalnızca temel dil kodlarıyla var. Bu olmadan 'tr-TR'
    // gibi bir tespit ayrı (ve var olmayan) bir kaynak isteğine dönerdi.
    load: 'languageOnly',
    supportedLngs: Object.keys(loaders),
    ns: ['translations'],
    nsSeparator: '~',
    defaultNS: 'translations',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
